import { ConfigurationService } from "../services/configuration.service"

interface OpenPartnerProjectDetailsOptions {
  recordId?: string
  projectId?: string | null
  newDesign?: boolean
}

/**
 * Open the my-iko partner "project details" page for a saved design.
 *
 * The design_token is minted server-side on demand (never stored) right before
 * navigating. A blank tab is opened synchronously inside the click handler so
 * the async token request does not trip the browser's popup blocker.
 */
export async function openPartnerProjectDetails({
  recordId,
  projectId,
  newDesign,
}: OpenPartnerProjectDetailsOptions): Promise<void> {
  const partnerWindow = window.open("", "_blank")
  if (partnerWindow) partnerWindow.opener = null

  const designToken = recordId
    ? await ConfigurationService.getDesignToken(recordId)
    : null

  const params = new URLSearchParams()
  if (projectId) params.append("project_id", projectId)
  if (designToken) params.append("design_token", designToken)
  if (newDesign) params.append("new_design", "true")

  const url = `${process.env.REACT_APP_MY_IKO_URL}project-details?${params.toString()}`

  if (partnerWindow) {
    partnerWindow.location.href = url
  } else {
    window.open(url, "_blank", "noopener,noreferrer")
  }
}
